// extracted by mini-css-extract-plugin
export default {"Items":"GenresItemStyle_Items__4g7Tr"};